import { defineReceiver, defineCommand } from '@drapejs/invoker';
import { gql } from 'graphql-request';
import { request, query } from '@motillo/drapejs-litium';
import { onMounted } from 'vue';

export const commands = {
    initSession: defineCommand<{
        url: string;
        samlResponse: string;
    }>('initSession'),
};

export const receivers = {
    initSession: defineReceiver(
        commands.initSession,
        async function (command, data) {
            const result = await request(
                this.cache,
                query(gql`
                    mutation initSession($url: String!, $samlResponse: String!){
                        session(url: $url) {
                            initSession {
                                initSession(samlResponse: $samlResponse) {
                                    address1
                                    city
                                    country
                                    email
                                    error
                                    firstName
                                    lastName
                                    phone
                                    redirectUrl
                                    zip
                                }
                            }
                        }
                    }
                `),
                {
                    url: `${(<any>command).protocol}//${(<any>command).host}${(<any>command).path}`,
                    samlResponse: command.samlResponse
                }
            );

            return result;
        },
        'litium'
    ),
};

onMounted